export const EDIT_ENTITY_MODAL = 'EDIT_ENTITY_MODAL';
export const EDIT_ENTITY_CONTACT_LINK = 'EDIT_ENTITY_CONTACT_LINK';
export const EDIT_PRINCIPAL_MODAL = 'EDIT_PRINCIPAL_MODAL';
export const DELETE_ENTITY_CONTACT_LINK = 'DELETE_ENTITY_CONTACT_LINK';
export const EDIT_COMPANY_MODAL = 'EDIT_COMPANY_MODAL';
export const DELETE_FOREVER_MODAL = 'DELETE_FOREVER_MODAL';
export const RECYCLE_BIN_MODAL = 'RECYCLE_BIN_MODAL';
export const ENTITY_AUDIT_HISTORY_MODAL = 'ENTITY_AUDIT_HISTORY_MODAL';
export const DELETE_COMPANY_CONTACT_LINK_MODAL = 'DELETE_COMPANY_CONTACT_LINK_MODAL';

export const setEditEntityModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_ENTITY_MODAL, state });
};

export const setEditBorrowerEntityToPrincipalLinkModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_ENTITY_CONTACT_LINK, state });
};

export const setEditPrincipalModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_PRINCIPAL_MODAL, state });
};

export const setDeleteBorrowerEntityToPrincipalLinkModal = (state) => (dispatch) => {
    dispatch({ type: DELETE_ENTITY_CONTACT_LINK, state });
};

export const setEditCompanyModal = (state) => (dispatch) => {
    dispatch({ type: EDIT_COMPANY_MODAL, state });
};

export const setDeleteForeverModal = (state) => (dispatch) => {
    dispatch({ type: DELETE_FOREVER_MODAL, state });
};

export const setRecycleBinModal = (state) => (dispatch) => {
    dispatch({ type: RECYCLE_BIN_MODAL, state });
};

export const setEntityAuditHistoryModal = (state) => (dispatch) => {
    dispatch({ type: ENTITY_AUDIT_HISTORY_MODAL, state });
};

export const setDeleteBusinessToPrincipalLinkModal = (state) => (dispatch) => {
    dispatch({ type: DELETE_COMPANY_CONTACT_LINK_MODAL, state });
};

export default {
    EDIT_ENTITY_MODAL,
    EDIT_ENTITY_CONTACT_LINK,
    EDIT_PRINCIPAL_MODAL,
    DELETE_ENTITY_CONTACT_LINK,
    EDIT_COMPANY_MODAL,
    DELETE_FOREVER_MODAL,
    RECYCLE_BIN_MODAL,
    ENTITY_AUDIT_HISTORY_MODAL,
    DELETE_COMPANY_CONTACT_LINK_MODAL,
    setEditEntityModal,
    setEditBorrowerEntityToPrincipalLinkModal,
    setEditPrincipalModal,
    setDeleteBorrowerEntityToPrincipalLinkModal,
    setEditCompanyModal,
    setDeleteForeverModal,
    setRecycleBinModal,
    setEntityAuditHistoryModal,
    setDeleteBusinessToPrincipalLinkModal,
};
